import { Link } from "react-router-dom";
import { photoUrl } from "@/lib/api";
import { MapPin, Clock } from "lucide-react";

const STATUS_STYLES = {
  available: "bg-[#7C3AED]/10 text-[#7C3AED]",
  claimed:   "bg-[#E5B15D]/15 text-[#9c7426]",
  gone:      "bg-[#A8A6A1]/20 text-[#6b6a66]",
};

function timeAgo(iso) {
  const d = new Date(iso);
  const sec = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
  if (sec < 60) return "just now";
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return `${Math.floor(sec / 86400)}d ago`;
}

export default function ItemCard({ item }) {
  const hero = item.photos?.[0];
  return (
    <Link to={`/items/${item.id}`} data-testid={`item-card-${item.id}`}
      className="group block fade-in-up">
      <div className="bg-white rounded-2xl border border-[#E8E5F0] overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:border-[#7C3AED]/40">
        <div className="relative aspect-[4/3] bg-[#EFEAF7] overflow-hidden">
          {hero ? (
            <img src={photoUrl(hero)} alt={item.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
          ) : (
            <div className="w-full h-full grid place-items-center text-[#A8A6A1]">No photo</div>
          )}
          <div className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[item.status]}`}>
            {item.status === "available" ? "Available" : item.status === "claimed" ? "Claimed" : "Gone"}
          </div>
        </div>
        <div className="p-4">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-display text-lg font-medium leading-tight tracking-tight line-clamp-1">{item.title}</h3>
            <span className="shrink-0 text-xs text-[#6B7280] inline-flex items-center gap-1">
              <Clock className="h-3 w-3" />{timeAgo(item.created_at)}
            </span>
          </div>
          <p className="text-sm text-[#6B7280] mt-1 line-clamp-1">
            <MapPin className="inline h-3 w-3 mr-1 -mt-0.5" />
            {item.address || `${item.lat.toFixed(3)}, ${item.lng.toFixed(3)}`}
          </p>
          <div className="flex items-center justify-between mt-3">
            <span className="text-xs uppercase tracking-[0.15em] text-[#7C3AED] font-medium">{item.category}</span>
            <span className="text-xs text-[#6B7280]">by {item.user_name}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
